const isEmptyString = (string?: string) => !string || /^\s*$/.test(string);

export default isEmptyString;
